import { Flex, Td, Text, Tr } from "@chakra-ui/react";
import { MovimentacaoFinanceira } from "../../utils/interfaces";
import { formatBRL } from "../../utils/currency";

export function MovimentoItem({item}: {item: MovimentacaoFinanceira}){
  return (
    <Tr color={item.tipo === 'D' ? 'green.700' : 'red.700'} p={0} className="group" key={`${item.id}-movimentos`}>
          <Td p={1} textAlign={"start"} fontSize={"md"}>
              {item.id}
          </Td>
          <Td
            p={1}
            textAlign={"start"}         
          >
            <Flex flexDir={'column'}>
              <Text as="span">{item.info}</Text>
              <Text as="span" fontSize={'xs'}>{item.usuario}</Text>
            </Flex>
          </Td>
          <Td p={1} textAlign={"start"} fontSize={"md"}>
            {item.created_at}
          </Td>
          <Td p={1} textAlign={"start"} fontSize={"md"}>
            {formatBRL(item.valor_bruto)}
          </Td>
          <Td p={1} textAlign={"start"} fontSize={"md"}>
            {formatBRL(item.valor_conveniencia)}
          </Td>
          <Td p={1} textAlign={"start"} fontSize={"md"}>
            {formatBRL(item.valor_taxa)}
          </Td>
          <Td p={1} textAlign={"start"} fontSize={"md"} fontWeight={'bold'}>
            {formatBRL(item.valor)}
          </Td>
          <Td p={1} textAlign={"start"} fontSize={"md"}>
            {formatBRL(item.saldo)}
          </Td>
        </Tr>
  )
}